<!-- 模块 Title -->
<style scoped>
h1 {
    line-height: 36px;
    text-align: center;
    color: #000000;
    font-size: 36px;
}
.line {
    display: block;
    width: 66px;
    height: 4px;
    margin: 16px auto 0;
    background-color: #04a0f7;
}
</style>
<template>
    <div class="modularTit">
        <h1>{{titleName}}</h1>
        <div class="line"></div>
    </div>
</template>
<script>
export default {
    name: 'modularTit',
    props: ['titleName']
}
</script>



// WEBPACK FOOTER //
// src/components/modularTit.vue